import { createRouter } from "@tanstack/react-router"

import { NotFound } from "./components/not-found.js"
import { routeTree } from "./routeTree.gen.js"

export const router = createRouter({ routeTree, defaultNotFoundComponent: NotFound })

/**
 * Makes every `Link`, `useParams` and `useSearch` in the app typed against this
 * router's tree rather than against `any`. Without it, file-based routing is
 * just string paths.
 */
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
